var moduleMap = {
	"./PhoneIntegration": () => {
		return __webpack_require__.e(636).then(() => (() => ((__webpack_require__(45644)))));
	},
	"./WhatsAppSettings": () => {
		return __webpack_require__.e(78).then(() => (() => ((__webpack_require__(6391)))));
	},
	"./WhatsAppHeaderSlot": () => {
		return __webpack_require__.e(572).then(() => (() => ((__webpack_require__(53572)))));
	},
	"./WhatsAppIntegration": () => {
		return __webpack_require__.e(400).then(() => (() => ((__webpack_require__(36926)))));
	},
	"./LocationNumbersManage": () => {
		return __webpack_require__.e(126).then(() => (() => ((__webpack_require__(75126)))));
	},
	"./LocationAdvancedSettings": () => {
		return __webpack_require__.e(99).then(() => (() => ((__webpack_require__(43467)))));
	},
	"./LocationTrustCenter": () => {
		return __webpack_require__.e(879).then(() => (() => ((__webpack_require__(73663)))));
	},
	"./LocationMessagingStats": () => {
		return __webpack_require__.e(555).then(() => (() => ((__webpack_require__(27555)))));
	},
	"./CreateTemplate": () => {
		return __webpack_require__.e(157).then(() => (() => ((__webpack_require__(42948)))));
	},
	"./CreateTemplateExporter": () => {
		return __webpack_require__.e(325).then(() => (() => ((__webpack_require__(13460)))));
	},
	"./MessagePreviewExporter": () => {
		return __webpack_require__.e(895).then(() => (() => ((__webpack_require__(65866)))));
	},
	"./WhatsAppMessagePreview": () => {
		return __webpack_require__.e(67).then(() => (() => ((__webpack_require__(23910)))));
	},
	"./vue3": () => {
		return __webpack_require__.e(130).then(() => (() => ((__webpack_require__(82130)))));
	},
	"./childStoreHook": () => {
		return __webpack_require__.e(14).then(() => (() => ((__webpack_require__(8014)))));
	},
	"./PiniaWrapper": () => {
		return __webpack_require__.e(685).then(() => (() => ((__webpack_require__(13685)))));
	},
	"./LocationRegulatoryCompliance": () => {
		return __webpack_require__.e(854).then(() => (() => ((__webpack_require__(39854)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});